import locale from '../locale/default';
export default locale;
//# sourceMappingURL=default.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/default.js
// module id = 861
// module chunks = 0